import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { FormErrorComponent } from '../form-error/form-error.component';

@Component({
  selector: 'is-checkbox-field',
  standalone: true,
  imports: [CommonModule, FormErrorComponent],
  template: `
    <div class="form-check mb-3">
      <input
        class="form-check-input"
        [class.is-invalid]="hasError"
        type="checkbox"
        [id]="checkId"
        [checked]="value"
        [disabled]="isDisabled"
        (change)="handleChange($event)"
        (blur)="handleBlur()"
      />
      <label class="form-check-label" [for]="checkId">
        {{ label }}
      </label>
      <is-form-error *ngIf="control" [control]="control"></is-form-error>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxFieldComponent),
      multi: true,
    },
  ],
})
export class CheckboxFieldComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() control: AbstractControl | null = null;

  private static idCounter = 0;
  readonly checkId = `is-checkbox-${++CheckboxFieldComponent.idCounter}`;

  value = false;
  isDisabled = false;

  private onChange: (val: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  get hasError(): boolean {
    return !!(this.control?.invalid && (this.control?.dirty || this.control?.touched));
  }

  writeValue(val: boolean): void {
    this.value = !!val;
  }

  registerOnChange(fn: (val: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.isDisabled = disabled;
  }

  handleChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.value = checked;
    this.onChange(checked);
  }

  handleBlur(): void {
    this.onTouched();
  }
}
